import { format } from './checkBox'

const radioButton = {
  format,
}

export default radioButton
